/**
 * Master entity names constants
 */

export const PERIOD_TYPE_NAME_SILVICULTURE = 'Cierre Quincenal Silvicultura';

export const PERIOD_TYPE_NAME_PLANNED_PLANNING_SEASON = 'Temporada Planeada Planeamiento';

export const REASON_GROUP_NAME_AREA_ADJUSTMENT = 'Ajuste de Área SIF';

export const REASON_GROUP_NAME_STAND_DEACTIVATION = 'Desactivación de cuadros';

export const REASON_GROUP_NAME_STAND_STATE = 'Estado Cuadro';

export const REASON_GROUP_NAME_NEGOTIATION_STATE = 'Estado Negociación';
